import { Route } from '../../config/router'
import { useEffect } from 'react'
import { useCheckoutError, useCheckoutState, useAppRouter, useCountry } from '../../state'
import { TrackingEvent, CheckoutStatus } from '../../model'
import { getIdentityVerificationRoute } from '../../model'
import { ErrorCode } from '@afterpaytouch/portal-api/types'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'

export const useCheckoutSummaryRouteGuard = (): void => {
  const { status } = useCheckoutState()
  const router = useAppRouter()
  const country = useCountry()
  const error = useCheckoutError()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  useEffect(() => {
    if (status <= CheckoutStatus.Loaded) {
      router.push(Route.LOGGED_IN)
    }

    if (status === CheckoutStatus.IdentityIneligible) {
      logEvent(TrackingEvent.TRIGGER_IDENTITY_REDIRECT_SUMMARY_PAGE)
      const url = getIdentityVerificationRoute(country, {}, error?.errorCode as ErrorCode) as Route
      router.push(url)
    }

    if (status === CheckoutStatus.LackOfEligiblePaymentMethod) {
      router.push(Route.ADD_PAYMENT_METHOD)
    }

    router.prefetch(Route.PAYMENT_METHOD)
    router.prefetch(Route.NEW_PAYMENT_METHOD)
  }, [status, router, country, error, logEvent])
}
